import { render } from "./PanelFirmas.vue?vue&type=template&id=1159d8ec&scoped=true"
import script from "./PanelFirmas.vue?vue&type=script&lang=js"
export * from "./PanelFirmas.vue?vue&type=script&lang=js"

import "./PanelFirmas.vue?vue&type=style&index=0&id=1159d8ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1159d8ec"]])

export default __exports__